import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAdobeInDesign32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconAdobeInDesign32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 7h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2M5 9a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4zm4.837 1.15V21h2.046V10.15zm5.165 10.617q.806.45 1.72.45 1.054 0 1.597-.357.558-.355.822-.79h.279V21h1.922V10.15h-1.953v4.045h-.28a1.9 1.9 0 0 0-.449-.527 2.3 2.3 0 0 0-.775-.402q-.465-.171-1.162-.171-.93 0-1.72.465-.791.45-1.272 1.333-.48.884-.48 2.139v.248q0 1.256.48 2.139t1.271 1.348m3.813-1.828q-.605.573-1.503.573-.899 0-1.504-.573-.604-.59-.604-1.706v-.155q0-1.116.604-1.689.604-.59 1.504-.589.914 0 1.503.589.605.573.605 1.69v.154q0 1.116-.605 1.706"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAdobeInDesign32);
